import { render, staticRenderFns } from "./merchantServiceAgreement.vue?vue&type=template&id=062eadce&scoped=true&"
import script from "./merchantServiceAgreement.vue?vue&type=script&lang=js&"
export * from "./merchantServiceAgreement.vue?vue&type=script&lang=js&"
import style0 from "./merchantServiceAgreement.vue?vue&type=style&index=0&id=062eadce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062eadce",
  null
  
)

export default component.exports